import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import { TypeApplicationStore } from '@stores/application-store';
import { injectStores } from '@stores/factories/store-utils';

import Header from '../components/menus/header/header';

import './jakhub.scss';

export interface Props {
    ApplicationStore: TypeApplicationStore;
}

function Jakhub(props: Props) {
    const {
        ApplicationStore: { applicationIsLoaded, closeMobileMenu },
    } = props;

    if (!applicationIsLoaded()) {
        return <div />;
    }

    return (
        <BrowserRouter>
            <div className='jakhub-parent container' onClick={closeMobileMenu}>
                <Header />
            </div>
        </BrowserRouter>
    );
}

export default injectStores(['ApplicationStore'])(Jakhub);
